import createClient, { Middleware } from "openapi-fetch";

import { paths } from "src/api/schema";
import { getConfig } from "src/config.ts";
import { loadAuthState } from "src/store/auth.ts";

let client: ReturnType<typeof createClient<paths>> | null = null;

const setupClient = (): ReturnType<typeof createClient<paths>> => {
  const c = createClient<paths>({ baseUrl: getConfig().apiUrl });
  const authMiddleware: Middleware = {
    async onRequest({ request }) {
      const authState = loadAuthState();
      if (authState !== null) {
        request.headers.set("Authorization", "Bearer " + authState.accessToken);
      }
      return request;
    },
  };
  c.use(authMiddleware);
  return c;
};

export const getClient = (): ReturnType<typeof createClient<paths>> => {
  if (client === null) {
    client = setupClient();
  }

  return client;
};
